/* eslint-disable */

import Vue from 'vue';
import axios from 'axios';
import qs from 'qs';
import Cookies from 'js-cookie';
import utils from '@/utils';
import {
  COOKIE_KEY, API_STATUS, API_RESPONSE_CODE
} from '@/constant';

// Full config:  https://github.com/axios/axios#request-config
if (process.env.NODE_ENV !== 'production') {
  axios.defaults.baseURL = '/api';
}
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};
const abortControllerMap = {};
const urlParam = utils.getParam();
const _axios = axios.create(config);
_axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
_axios.interceptors.request.use((config) => {
  // Do something before request is sent
  if (config) {
    if (config.singleInstance) {
      const requestKey = `${config.method}-${config.url}`;
      abortControllerMap[requestKey]?.abort();
      const controller = new AbortController();
      abortControllerMap[requestKey] = controller;
      config.signal = controller.signal;
    }
    config.params = config.params || {};
    config.data = config.data || {};
    if (!config.withoutExtraParam) {
      const token = urlParam.token || Cookies.get(COOKIE_KEY.TOKEN);
      if (token) {
        config.data.token = token;
        if (config.formData) {
          config.params.token = token;
        }
      }
      if (window.settings.companyId) {
        // todo
        config.data.company_id = window.settings.companyId;
      }
    }
    if (config.method === 'get') {
      config.params = config.data;
    } else if (!config.formData && !config.json) {
      config.data = qs.stringify(config.data);
    } else if (config.json) {
      config.headers['Content-Type'] = 'application/json';
    }
  }
  return config;
}, error => // Do something with request error
  Promise.reject(error),);

_axios.interceptors.response.use((response) => {
  // Do something with response data
  if (response && response.data) {
    const result = response.data;
    result.success = false;
    if (result.res === API_STATUS.SUCCESS
      || (result.res !== API_STATUS.FAIL && result.errMsg === 'request:ok')
      || result.errcode === API_RESPONSE_CODE.SUCCESS
      || result.data && response.config.withoutExtraParam) {
      result.success = true;
    } else if (result.code === API_RESPONSE_CODE.NOT_LOGIN) {
      window.location.href = 'login.html';
    } else {
      window.instanceObj.$message.error(result.message || '获取数据失败');
    }
    return result;
  }
  return response;
}, error => {
  window.instanceObj.$message.error(error.message || '服务内部错误');
  return Promise.reject(error)
});

Plugin.install = function (Vue, options) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      },
    },
    $axios: {
      get() {
        return _axios;
      },
    },
  });
};

Vue.use(Plugin);

export default Plugin;
